import { Requirement } from "@siteimprove/alfa-act";
/**
 * @public
 */
export class BestPractice extends Requirement {
    static of(uri) {
        return new BestPractice(uri);
    }
    constructor(uri) {
        super("best practice", uri);
    }
    toJSON() {
        return super.toJSON();
    }
}
/**
 * @public
 */
(function (BestPractice) {
    function isBestPractice(value) {
        return value instanceof BestPractice;
    }
    BestPractice.isBestPractice = isBestPractice;
})(BestPractice || (BestPractice = {}));
//# sourceMappingURL=best-practice.js.map